import * as googleMap from "@elements/google-map";
import {find, findIn, findAll} from "@elements/dom-utils"
import {onFind} from "@elements/init-modules-in-scope";
import {onEnterViewPort} from "@elements/viewport-utils";


const isMobile = () => matchMedia('(max-width: 767px)').matches;

export function init () {
    onFind('.js-google-map', function (mapElement) {

        let poiVarName = mapElement.dataset.googleMapPois;
        let pois = [];

        if (poiVarName) {
            if (!window['_googleMapPois']) {
                console.error('_googleMapPois is not set');
            } else if (!window._googleMapPois[poiVarName]) {
                console.error(poiVarName + ' is not set in _googleMapPois', _googleMapPois);
            } else {
                pois = _googleMapPois[poiVarName];
            }
        }

        onEnterViewPort(find('.js-google-map'), function (element) {
            let map = googleMap.init({
                element: mapElement,
                pois: pois,
                mapOptions: {
                    center: {lat: 47.076668, lng: 15.421371},
                    zoom: 14,
                    maxZoom: 18,
                    scrollwheel: true,
                    mapTypeControl: false,
                    streetViewControl: false,
                    style: getMapStyling()
                },
                poiStyles: () => createPoiStyles(),
                infoBoxOptions: () => getGoogleInfoBoxOptions(),
                clustering: true,
                clusteringOptions: createClusterStyles(),
                onActivateMarker: (marker, api) => onActivateMarker(marker, api),
                onDeactivateMarker: (marker, api) => onDeactivateMarker( marker, api),
            });

            googleMap.getApi(element).then((api) => {
                api.centerMap();
            });
        }, {
            offset: 0
        });
    });
}

export function createClusterStyles() {
    return {
        default: {
            styles: [{
                height: 56,
                url: "/static/build/img/pois/cluster.svg",
                width: 56,
                textSize: 18,
                textColor: "#245685"
            }]
        }
    }
}

export function createPoiStyles() {
    return {
        main: {
            default: {
                url: '/static/build/img/pois/poi-empty.svg',
                size: new google.maps.Size(56, 56),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(28, 28)
            },
            active: {
                url: '/static/build/img/pois/poi-empty-active.svg',
                size: new google.maps.Size(56, 56),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(28, 28)
            }
        }
    }
}


export function onActivateMarker(marker, api) {
    if(marker.detailInfoBoxUrl) {
        let infoBoxPromise = api.showInfoBoxByMarker(
            marker,
            ` <div class="loading-spinner" aria-label="loading...">
                    <div class="loading-spinner__item loading-spinner__item--1"></div>
                    <div class="loading-spinner__item loading-spinner__item--2"></div>
                    <div class="loading-spinner__item loading-spinner__item--3"></div>
                </div>`
        );

        let contentPromise = fetch(marker.detailInfoBoxUrl, {
            method: 'GET',
            headers: {"content-type": "application/json"}
        }).then((res) => {
            return res.json()
        });

        Promise.all([infoBoxPromise, contentPromise]).then(([infoBox, response]) => {
            infoBox.setContent(response.html);
        });
    }
}

export function onDeactivateMarker(marker, api) {
    api.closeInfoBoxByMarker(marker);
}

export function getMapStyling() {
    return  [
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
    ];
}

export function getGoogleInfoBoxOptions(){
    let width = isMobile() ? "200px" : "450px";
    let offsetX = isMobile() ? -5 : -5;
    let offsetY = isMobile() ? 5 : 5;

    return {
        zIndex:-1,
        pixelOffset: new google.maps.Size(offsetX, offsetY),
        boxStyle: {width: width, padding: "0"},
        boxClass: "info-box",
        closeBoxURL: "/static/icons/svg/close.svg"
    };
}